<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<h1>Testing templates</h1>
		<div class="margin-top">
			<MaterialText
				label="Create new template"
				v-model="create.name"
				v-on:enter="createTemplate"
				/>
			<button
				v-on:click="createTemplate"
				:disabled="saving">Create</button>
		</div>

		<Modal
			v-if="run"
			v-on:close="closeRun">

			<button
				:disabled="running"
				class="small small-margin-bottom"
				v-on:click="closeRun(true)">Edit</button>

			<div
				class="progress-bar">
				<div
					class="bar"
					:style="'width: ' + (100 * run_progress / run.items.length) + '%'"></div>
			</div>

			<div
				class="small-margin-bottom text-center"
				style="font-size: 13px; margin-top: 5px;">
				{{ run_progress }} / {{ run.items.length }} tasks completed
			</div>

			<div
				v-if="progress_error"
				class="margin-bottom progress-error">
				{{ progress_error }}
			</div>

			<div class="progress-items">
				<div
					class="progress-item"
					v-bind:class="{
						succeeded: i < run_progress,
						failed: i == run_progress - 1 && progress_error,
						running: i == run_progress && !progress_error,
					}"
					v-for="(item, i) in run.items">
					<div class="circle"></div>
					<div class="method">{{ item.method }}</div>
				</div>
			</div>

			<div
				class="margin-top"
				v-if="run_output">
				<template v-if="run_output.customer">
					<a :href="'/#/testing?uid=' + run_output.customer.id">Go to Testing area</a>
					<br />
					<a :href="'/#/customer/' + run_output.customer.id">Go to customer profile</a>
					<div
						class="margin-top"
						v-if="run_output.orders.length > 0">
						<div
							v-for="order in run_output.orders">
							<a :href="'/#/order/' + order.id">
								Open order {{ order.id }}
								<template v-if="order.order_type_id == 1">(Styling)</template>
								<template v-else-if="order.order_type_id == 2">(Webshop)</template>
								<template v-else-if="order.order_type_id == 3">(Fee)</template>
								<template v-else-if="order.order_type_id == 4">(Exchange)</template>
							</a>
						</div>
					</div>
				</template>
			</div>

		</Modal>

		<Modal
			v-if="edit"
			v-on:close="edit = null"
			:modal-width="1000">
			<TestingTemplateEditor
				:id="edit.id"
				v-on:run="runAfterEdit" />
		</Modal>

		<table class="basic">
			<thead>
				<tr>
					<th>#</th>
					<th>Name</th>
					<th>Functions</th>
				</tr>
			</thead>
			<tbody>
				<tr
					v-for="row in records.testing_templates">
					<td>{{ row.id }}</td>
					<td>{{ row.name }}</td>
					<td>
						<button
							:disabled="saving"
							v-on:click="execute(row)"
							class="small small-margin-right">Run</button>
						<button
							:disabled="saving"
							v-on:click="edit = row"
							class="small small-margin-right">Edit</button>
						<button
							:disabled="saving"
							v-on:click="deleteTemplate(row)"
							class="small gray">Delete</button>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import TestingTemplateEditor from '@/components/testing/TestingTemplateEditor.vue'

export default {
  components: {
    TestingTemplateEditor
  },
  data: () => ({
    loading: false,
    saving: false,
    edit: null,
    records: [],
    methods: [],
    create: {},
    run: null,
    run_output: null,
    run_progress: 0,
    running: false,
    progress_error: null
  }),
  computed: {
  },
  methods: {
    execute (row) {
      this.run = row
      this.run_progress = 0
      this.running = true
      this.progress_error = null

      Vue.$api.post('/testing-template/' + row.id + '/run', {}, {
        before: () => {
          this.saving = true
          this.running = true
        },
        always: () => {
          this.saving = false
          this.running = false
        },
        onProgress: data => this.handleProgress(data),
        callback: data => this.onExecuted(data),
        errorMessage: msg => this.onFailed(msg),
        error: msg => this.onFailed(msg)
      })
    },
    onFailed (data) {
      this.progress_error = data
    },
    onExecuted (data) {
      const json = JSON.parse(data.replace(/^\d*/, ''))

      if (json.exception) {
        this.progress_error = json.message
      }
    },
    closeRun (openEditor) {
      if (openEditor) {
        this.edit = this.run
      }

      this.run = null
      this.run_output = null
      this.run_progress = 0
    },
    handleProgress (data) {
      if (this.run_progress < this.run.items.length) {
        this.run_progress++
      }

      const response = data.srcElement.responseText

      if (response.match(/^\d*\{/)) {
        this.run_output = JSON.parse(response.replace(/^\d+/, ''))
      }
    },
    deleteTemplate (row) {
      if (!confirm('Are you sure?')) {
        return
      }

      Vue.$api.delete('/testing-template/' + row.id, {}, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => {
          this.load()
        }
      })
    },
    createTemplate () {
      Vue.$api.post('/testing-template', this.create, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => {
          this.load()
        }
      })
    },
    load (callback) {
      Vue.$api.get('/testing-template', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.onLoad(data, callback)
      })
    },
    onLoad (data, callback) {
      this.records = data
      this.methods = data.methods

      if (callback) {
        callback()
      }
    },
    runAfterEdit () {
      var id = this.edit.id

      this.edit = null

      this.load(() => {
        for (var row of this.records.testing_templates) {
          if (row.id == id) {
            this.execute(row)
          }
        }
      })
    }
  },
  created () {
    console.log('has', this.$route.query.run)
    this.load(() => {
      const runTest = this.$route.query.run
      console.log(runTest)
      if (runTest) {
        for (var row of this.records.testing_templates) {
          if (row.id == runTest) {
            this.execute(row)
          }
        }
      }
    })
  }
}
</script>

<style lang="less" scoped>
	.progress-item {
		border: 1px solid #ddd;
		// border-top: none;
		padding: 10px;
		display: flex;
		align-items: center;
		margin-bottom: 4px;
		border-radius: 4px;
		&:first-child {
			// border-top: 1px solid #ddd;
		}
		.circle {
			margin-right: 8px;
			width: 12px;
			height: 12px;
			border-radius: 50%;
			background: #bbb;
		}
		&.succeeded {
			border-color: #3AB300;
			color: #3AB300;
			.circle {
				background: #3AB300;
			}
		}
		&.failed {
			border-color: #CA000F;
			color: #CA000F;
			.circle {
				background: #CA000F;
			}
		}
		&.running {
			border-color: #043988;
			color: #043988;
			.circle {
				background: #043988;
				animation-name: running;
				animation-duration: 1s;
				animation-iteration-count: infinite;
			}
		}
	}
	.progress-error {
		padding: 12px;
		padding-left: 13px;
		// font-weight: 900;
		border: 1px solid red;
		color: red;
		border-radius: 4px;
	}
	.progress-bar {
		height: 15px;
		padding: 3px;
		// width: 400px;
		border: 1px solid #ddd;
		border-radius: 4px;
		.bar {
			height: 100%;
			background: blue;
			border-radius: 4px;
			transition: 300ms;
		}
	}

	@keyframes running {
		50% {
			background: red;
		}
	}
</style>
